import React, { useState, useEffect, useCallback } from "react"
import { Helmet } from "react-helmet-async"
import ScrollToTop from "../../ScrollToTop"
import CartIcon from "../../components/CartIcon"
import CartDropdown from "../../components/CartDropdown"
import {
  Icon,
  LeftIcon,
  NavContainer,
  NavLogo,
  NavButton,
  ProductDetailContainer,
  ProductDetailWrapper,
  ProductImageContainer,
  ImageContainer,
  BigImageWrap,
  SmallImageWrap,
  Img,
  ReferenceOnlyP,
  RemarksP,
  ProductInfoContainer,
  Title,
  Description,
  CakePrice,
  DTSelectorWrapper,
  TwoColumnInOneRow,
  AddToCartButton,
  ChefImageWrap,
  PremiumImageWrap,
  NewImageWrap,
  ImageOverflowWrap,
  ErrorMessage,
  TopperContainer,
  TopperWrapper,
  AddonSelectionWrapper,
  AddonSelectionP,
  DeleteIcon,
  AddonTitle,
  AddonSectionTitle,
  AddonCardWrapper,
  AlertMessage,
  AlertIcon,
} from "./ProductDetailsElements"
import SelectInput from "../../components/SelectInput"
import FormInput from "../../components/FormInput"
import Chef from "./chef.svg"
import Premium from "./premium.svg"
import New from "./new.svg"

import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers"
import { FiCalendar } from "react-icons/fi"
import DateFnsUtils from "@date-io/date-fns"

import { connect } from "react-redux"
import { selectSingleLineUpCake } from "../../redux/cake/cake.selectors"
import { selectCartItemsCount, selectCartHidden } from "../../redux/cart/cart.selectors"
import { addCake, toggleCartHidden, toggleCloseCart } from "../../redux/cart/cart.actions"
import Footer from "../../components/Footer"
import Tabs from "../../components/Tabs"
import Checkbox from "../../components/Checkbox"
import TextAreaInput from "../../components/TextAreaInput"

import { Player } from "@lottiefiles/react-lottie-player"

const ProductDetails = ({ lineUp, addCake, toggleCartHidden, showDropdown, closeCart }) => {
  const { gallery, name, description, price, alt, custom, premium, featured, newFlavour, lottie, addOn } = lineUp
  const [selectedImg, setSelectedImg] = useState(gallery[0])

  const now = new Date().getTime()
  const dayAfterTomorrow = new Date(now + 1000 * 60 * 60 * 24 * 2)

  const [cakePrice, setCakePrice] = useState(price)
  const [size, setSize] = useState("6 Inch")
  const [deliveryDate, setDeliveryDate] = useState(dayAfterTomorrow)
  const [deliveryTime, setDeliveryTime] = useState("Any Time")
  const [candle, setCandle] = useState("No Candle")
  const [error, setError] = useState("")
  const [isForcePickerOpen, setIsOpen] = useState(false)

  const [addonAccessories, setAddonAccessories] = useState({})

  const [selectDebossingTag, setSelectDebossingTag] = useState(false)
  const [debossingTagNote, setDebossingTagNote] = useState("")

  const [selectEmbossingTag, setSelectEmbossingTag] = useState(false)
  const [embossingTagNote, setEmbossingTagNote] = useState("")

  const [selectLuggageTag, setSelectLuggageTag] = useState(false)
  const [luggageTagNote, setLuggageTagNote] = useState("")

  const [selectRibbonTag, setSelectRibbonTag] = useState(false)
  const [ribbonTagNote, setRibbonTagNote] = useState("")

  const [selectMiniTopper, setSelectMiniTopper] = useState(false)
  const [miniTopperNote, setMiniTopperNote] = useState("")

  const [selectTopper, setSelectTopper] = useState(false)
  const [topperNote, setTopperNote] = useState("")

  const [isGiftCard, setIsGiftCard] = useState(false)
  const [giftCardNote, setGiftCardNote] = useState("")
  const [shape, setShape] = useState("")

  // Handler
  const handleSizeChange = (event) => {
    setSize(event.target.value)

    switch (event.target.value) {
      case "4 Inch":
        return setCakePrice(Math.round(price * 0.77))
      case "5 Inch":
        return setCakePrice(Math.round(price * 0.88))
      case "6 Inch":
        return setCakePrice(Math.round(price))
      case "7 Inch":
        return setCakePrice(Math.round(price * 1.2))
      case "8 Inch":
        return setCakePrice(Math.round(price * 1.5))
      default:
        return
    }
  }

  const cakeSizeSelection = (value) => {
    if (value.custom) {
      return ["Custom Size"]
    } else if (value.premium) {
      return ["6 Inch"]
    } else if (value.allSize) {
      return ["4 Inch", "5 Inch", "6 Inch", "7 Inch", "8 Inch"]
    } else if (value.min6inch) {
      return ["6 Inch", "7 Inch", "8 Inch"]
    } else {
      return ["4 Inch", "6 Inch", "7 Inch", "8 Inch"]
    }
  }

  const handleDateChange = (date) => {
    setDeliveryDate(date)
  }

  const handleTimeChange = (event) => {
    setDeliveryTime(event.target.value)
  }

  const handleCandleChange = (event) => {
    setCandle(event.target.value)
  }

  const handleSelected = (event) => {
    setAddonAccessories(event)
    if (event.name === "Debossing Tag") {
      setSelectDebossingTag(true)
      setSelectEmbossingTag(false)
      setSelectLuggageTag(false)
      setSelectRibbonTag(false)
      setSelectMiniTopper(false)
      setSelectTopper(false)
      setShape("Round")
      setEmbossingTagNote("")
      setLuggageTagNote("")
      setRibbonTagNote("")
      setMiniTopperNote("")
      setTopperNote("")
    } else if (event.name === "Embossing Tag") {
      setSelectDebossingTag(false)
      setSelectEmbossingTag(true)
      setSelectLuggageTag(false)
      setSelectRibbonTag(false)
      setSelectMiniTopper(false)
      setSelectTopper(false)
      setShape("Round")
      setDebossingTagNote("")
      setLuggageTagNote("")
      setRibbonTagNote("")
      setMiniTopperNote("")
      setTopperNote("")
    } else if (event.name === "Luggage Tag") {
      setSelectDebossingTag(false)
      setSelectEmbossingTag(false)
      setSelectLuggageTag(true)
      setSelectRibbonTag(false)
      setSelectMiniTopper(false)
      setSelectTopper(false)
      setDebossingTagNote("")
      setEmbossingTagNote("")
      setRibbonTagNote("")
      setMiniTopperNote("")
      setTopperNote("")
    } else if (event.name === "Ribbon Tag") {
      setSelectDebossingTag(false)
      setSelectEmbossingTag(false)
      setSelectLuggageTag(false)
      setSelectRibbonTag(true)
      setSelectMiniTopper(false)
      setSelectTopper(false)
      setDebossingTagNote("")
      setEmbossingTagNote("")
      setLuggageTagNote("")
      setMiniTopperNote("")
      setTopperNote("")
    } else if (event.name === "Mini Topper") {
      setSelectDebossingTag(false)
      setSelectEmbossingTag(false)
      setSelectLuggageTag(false)
      setSelectRibbonTag(false)
      setSelectMiniTopper(true)
      setSelectTopper(false)
      setShape("Flag")
      setDebossingTagNote("")
      setEmbossingTagNote("")
      setLuggageTagNote("")
      setRibbonTagNote("")
      setTopperNote("")
    } else if (event.name === "Topper") {
      setSelectDebossingTag(false)
      setSelectEmbossingTag(false)
      setSelectLuggageTag(false)
      setSelectRibbonTag(false)
      setSelectMiniTopper(false)
      setSelectTopper(true)
      setDebossingTagNote("")
      setEmbossingTagNote("")
      setLuggageTagNote("")
      setRibbonTagNote("")
      setMiniTopperNote("")
    }
  }

  const handleDeselectAddon = () => {
    setAddonAccessories({})
    setSelectDebossingTag(false)
    setSelectEmbossingTag(false)
    setSelectLuggageTag(false)
    setSelectRibbonTag(false)
    setSelectMiniTopper(false)
    setSelectTopper(false)
    setDebossingTagNote("")
    setEmbossingTagNote("")
    setLuggageTagNote("")
    setRibbonTagNote("")
    setMiniTopperNote("")
    setTopperNote("")
  }

  const selectGiftCard = () => {
    setIsGiftCard(!isGiftCard)
    setGiftCardNote("")
  }

  const handleShapeChange = (event) => {
    setShape(event.target.value)
  }

  // Render more field
  const renderSelectedField = (value) => {
    switch (value) {
      case "Debossing Tag":
        return (
          <div>
            <AddonSelectionWrapper>
              <AddonSelectionP onClick={handleDeselectAddon}>
                + Add {addonAccessories.name}: RM {addonAccessories.price}
              </AddonSelectionP>
              <DeleteIcon onClick={handleDeselectAddon}>Delete</DeleteIcon>
            </AddonSelectionWrapper>
            <SelectInput
              removeSpacing
              label="Shape"
              name="cakeShape"
              handleChange={handleShapeChange}
              value={shape}
              options={["Round", "Rectangle", "Flag"]}
            />
            <FormInput
              autoComplete="none"
              name="debossingNote"
              type="text"
              handleChange={(e) => setDebossingTagNote(e.target.value)}
              value={debossingTagNote}
              label="Message (max. 30 characters)"
              maxLength="33"
            />
          </div>
        )
      case "Embossing Tag":
        return (
          <div>
            <AddonSelectionWrapper>
              <AddonSelectionP onClick={handleDeselectAddon}>
                + Add {addonAccessories.name}: RM {addonAccessories.price}
              </AddonSelectionP>
              <DeleteIcon onClick={handleDeselectAddon}>Delete</DeleteIcon>
            </AddonSelectionWrapper>
            <SelectInput
              removeSpacing
              label="Shape"
              name="cakeShape"
              handleChange={handleShapeChange}
              value={shape}
              options={["Round", "Rectangle"]}
            />
            <FormInput
              autoComplete="none"
              name="embossingNote"
              type="text"
              handleChange={(e) => setEmbossingTagNote(e.target.value)}
              value={embossingTagNote}
              label="Message (max. 30 characters)"
              maxLength="33"
            />
          </div>
        )
      case "Luggage Tag":
        return (
          <div>
            <AddonSelectionWrapper>
              <AddonSelectionP onClick={handleDeselectAddon}>
                + Add {addonAccessories.name}: RM {addonAccessories.price}
              </AddonSelectionP>
              <DeleteIcon onClick={handleDeselectAddon}>Delete</DeleteIcon>
            </AddonSelectionWrapper>
            <FormInput
              autoComplete="none"
              name="luggageNote"
              type="text"
              handleChange={(e) => setLuggageTagNote(e.target.value)}
              value={luggageTagNote}
              label="Message (max. 30 characters)"
              maxLength="33"
            />
          </div>
        )
      case "Ribbon Tag":
        return (
          <div>
            <AddonSelectionWrapper>
              <AddonSelectionP onClick={handleDeselectAddon}>
                + Add {addonAccessories.name}: RM {addonAccessories.price}
              </AddonSelectionP>
              <DeleteIcon onClick={handleDeselectAddon}>Delete</DeleteIcon>
            </AddonSelectionWrapper>
            <FormInput
              autoComplete="none"
              name="ribbonNote"
              type="text"
              handleChange={(e) => setRibbonTagNote(e.target.value)}
              value={ribbonTagNote}
              label="Message (max. 30 characters)"
              maxLength="33"
            />
          </div>
        )
      case "Mini Topper":
        return (
          <div>
            <AddonSelectionWrapper>
              <AddonSelectionP onClick={handleDeselectAddon}>
                + Add {addonAccessories.name}: RM {addonAccessories.price}
              </AddonSelectionP>
              <DeleteIcon onClick={handleDeselectAddon}>Delete</DeleteIcon>
            </AddonSelectionWrapper>
            <SelectInput
              removeSpacing
              label="Shape"
              name="cakeShape"
              handleChange={handleShapeChange}
              value={shape}
              options={["Flag", "Round"]}
            />
            <FormInput
              autoComplete="none"
              name="miniTopperNote"
              type="text"
              handleChange={(e) => setMiniTopperNote(e.target.value)}
              value={miniTopperNote}
              label="Message (max. 30 characters)"
              maxLength="33"
            />
          </div>
        )
      case "Topper":
        return (
          <div>
            <AddonSelectionWrapper>
              <AddonSelectionP onClick={handleDeselectAddon}>
                + Add {addonAccessories.name}: RM {addonAccessories.price}
              </AddonSelectionP>
              <DeleteIcon onClick={handleDeselectAddon}>Delete</DeleteIcon>
            </AddonSelectionWrapper>
            <FormInput
              autoComplete="none"
              name="topperNote"
              type="text"
              handleChange={(e) => setTopperNote(e.target.value)}
              value={topperNote}
              label="Name (max. 6 characters)"
              maxLength="6"
            />
          </div>
        )
      default:
        return
    }
  }

  // Price after addon
  const addonDebossingTagPrice = selectDebossingTag ? addonAccessories.price : 0
  const addonEmbossingTagPrice = selectEmbossingTag ? addonAccessories.price : 0
  const addonLuggageTagPrice = selectLuggageTag ? addonAccessories.price : 0
  const addonRibbonTagPrice = selectRibbonTag ? addonAccessories.price : 0
  const addonMiniTopperPrice = selectMiniTopper ? addonAccessories.price : 0
  const addonTopperPrice = selectTopper ? addonAccessories.price : 0
  const addonGiftCard = isGiftCard ? 8 : 0

  const cakePriceWithAddon =
    cakePrice +
    addonDebossingTagPrice +
    addonEmbossingTagPrice +
    addonLuggageTagPrice +
    addonRibbonTagPrice +
    addonMiniTopperPrice +
    addonTopperPrice +
    addonGiftCard

  // Only disabled specific date

  const notAvailableDate0503 = new Date("2024-05-01T00:00")
  const notAvailableDate0504 = new Date("2024-05-02T00:00")
  const notAvailableDate0505 = new Date("2024-05-03T00:00")
  const notAvailableDate0506 = new Date("2024-05-04T00:00")
  const notAvailableDate0507 = new Date("2024-05-05T00:00")

  const notAvailableDate0511 = new Date("2024-05-06T00:00")
  const notAvailableDate0512 = new Date("2024-05-07T00:00")
  const notAvailableDate0513 = new Date("2024-05-08T00:00")
  const notAvailableDate0514 = new Date("2024-05-09T00:00")
  const notAvailableDate0515 = new Date("2024-05-10T00:00")
  const notAvailableDate0516 = new Date("2024-05-11T00:00")
  const notAvailableDate0517 = new Date("2024-05-12T00:00")

  const notAvailableDate0521 = new Date("2024-05-13T00:00")
  const notAvailableDate0522 = new Date("2024-05-14T00:00")
  const notAvailableDate0523 = new Date("2024-05-15T00:00")
  const notAvailableDate0524 = new Date("2024-05-16T00:00")
  const notAvailableDate0525 = new Date("2024-05-17T00:00")
  const notAvailableDate0526 = new Date("2024-05-18T00:00")
  const notAvailableDate0527 = new Date("2024-05-19T00:00")

  const notAvailableDate0531 = new Date("2024-05-20T00:00")
  const notAvailableDate0532 = new Date("2024-05-21T00:00")
  const notAvailableDate0533 = new Date("2024-05-22T00:00")
  const notAvailableDate0534 = new Date("2024-05-23T00:00")
  const notAvailableDate0535 = new Date("2024-05-24T00:00")
  const notAvailableDate0536 = new Date("2024-05-25T00:00")
  const notAvailableDate0537 = new Date("2024-05-26T00:00")

  const notAvailableDate0541 = new Date("2024-05-27T00:00")
  const notAvailableDate0542 = new Date("2024-05-28T00:00")
  const notAvailableDate0543 = new Date("2024-05-29T00:00")
  const notAvailableDate0544 = new Date("2024-05-30T00:00")
  const notAvailableDate0545 = new Date("2024-05-31T00:00")

  const disabledDate = (date) => {
    return (
      date.getTime() === new Date("2024-05-01T00:00").getTime() ||
      date.getTime() === new Date("2024-05-02T00:00").getTime() ||
      date.getTime() === new Date("2024-05-03T00:00").getTime() ||
      date.getTime() === new Date("2024-05-04T00:00").getTime() ||
      date.getTime() === new Date("2024-05-05T00:00").getTime() ||
      date.getTime() === new Date("2024-05-06T00:00").getTime() ||
      date.getTime() === new Date("2024-05-07T00:00").getTime() ||

      date.getTime() === new Date("2024-05-08T00:00").getTime() ||
      date.getTime() === new Date("2024-05-09T00:00").getTime() ||
      date.getTime() === new Date("2024-05-10T00:00").getTime() ||
      date.getTime() === new Date("2024-05-11T00:00").getTime() ||
      date.getTime() === new Date("2024-05-12T00:00").getTime() ||
      date.getTime() === new Date("2024-05-13T00:00").getTime() ||
      date.getTime() === new Date("2024-05-14T00:00").getTime() ||

      date.getTime() === new Date("2024-05-15T00:00").getTime() ||
      date.getTime() === new Date("2024-05-16T00:00").getTime() ||
      date.getTime() === new Date("2024-05-17T00:00").getTime() ||
      date.getTime() === new Date("2024-05-18T00:00").getTime() ||
      date.getTime() === new Date("2024-05-19T00:00").getTime() ||
      date.getTime() === new Date("2024-05-20T00:00").getTime() ||
      date.getTime() === new Date("2024-05-21T00:00").getTime() ||

      date.getTime() === new Date("2024-05-22T00:00").getTime() ||
      date.getTime() === new Date("2024-05-23T00:00").getTime() ||
      date.getTime() === new Date("2024-05-24T00:00").getTime() ||
      date.getTime() === new Date("2024-05-25T00:00").getTime() ||
      date.getTime() === new Date("2024-05-26T00:00").getTime() ||
      date.getTime() === new Date("2024-05-27T00:00").getTime() ||
      date.getTime() === new Date("2024-05-28T00:00").getTime() ||

      date.getTime() === new Date("2024-05-29T00:00").getTime() ||
      date.getTime() === new Date("2024-05-30T00:00").getTime() ||
      date.getTime() === new Date("2024-05-31T00:00").getTime()
    )
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    // Only disabled specific date
    if (
      deliveryDate.getDate() === notAvailableDate0503.getDate() ||
      deliveryDate.getDate() === notAvailableDate0504.getDate() ||
      deliveryDate.getDate() === notAvailableDate0505.getDate() ||
      deliveryDate.getDate() === notAvailableDate0506.getDate() ||
      deliveryDate.getDate() === notAvailableDate0507.getDate() ||

      deliveryDate.getDate() === notAvailableDate0511.getDate() ||
      deliveryDate.getDate() === notAvailableDate0512.getDate() ||
      deliveryDate.getDate() === notAvailableDate0513.getDate() ||
      deliveryDate.getDate() === notAvailableDate0514.getDate() ||
      deliveryDate.getDate() === notAvailableDate0515.getDate() ||
      deliveryDate.getDate() === notAvailableDate0516.getDate() ||
      deliveryDate.getDate() === notAvailableDate0517.getDate() ||

      deliveryDate.getDate() === notAvailableDate0521.getDate() ||
      deliveryDate.getDate() === notAvailableDate0522.getDate() ||
      deliveryDate.getDate() === notAvailableDate0523.getDate() ||
      deliveryDate.getDate() === notAvailableDate0524.getDate() ||
      deliveryDate.getDate() === notAvailableDate0525.getDate() ||
      deliveryDate.getDate() === notAvailableDate0526.getDate() ||
      deliveryDate.getDate() === notAvailableDate0527.getDate() ||

      deliveryDate.getDate() === notAvailableDate0531.getDate() ||
      deliveryDate.getDate() === notAvailableDate0532.getDate() ||
      deliveryDate.getDate() === notAvailableDate0533.getDate() ||
      deliveryDate.getDate() === notAvailableDate0534.getDate() ||
      deliveryDate.getDate() === notAvailableDate0535.getDate() ||
      deliveryDate.getDate() === notAvailableDate0536.getDate() ||
      deliveryDate.getDate() === notAvailableDate0537.getDate() ||
      
      deliveryDate.getDate() === notAvailableDate0541.getDate() ||
      deliveryDate.getDate() === notAvailableDate0542.getDate() ||
      deliveryDate.getDate() === notAvailableDate0543.getDate() ||
      deliveryDate.getDate() === notAvailableDate0544.getDate() ||
      deliveryDate.getDate() === notAvailableDate0545.getDate()
      ) {
      setError("Date Not available / Order Full")
      return
    }
    setError("")

    // Add to redux cartItem
    addCake({
      selectDebossingTag,
      debossingTagNote,
      selectEmbossingTag,
      embossingTagNote,
      selectLuggageTag,
      luggageTagNote,
      selectRibbonTag,
      ribbonTagNote,
      selectMiniTopper,
      miniTopperNote,
      selectTopper,
      topperNote,
      shape,
      isGiftCard,
      giftCardNote,
      addonAccessories,
      cakePrice,
      cakePriceWithAddon,
      size,
      candle,
      date: String(deliveryDate),
      deliveryTime,
      cake: lineUp,
      uuid: Date.now(),
    })
    toggleCartHidden()
  }

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape") {
        closeCart()
      }
    },
    [closeCart]
  )

  useEffect(() => {
    document.addEventListener("keydown", keyPress)

    const body = document.querySelector("body")
    body.style.overflow = showDropdown ? "hidden" : "auto"

    return () => {
      document.removeEventListener("keydown", keyPress)
      const body = document.querySelector("body")
      body.style.overflow = "auto"
    }
  }, [keyPress, showDropdown])

  return (
    <>
      <ScrollToTop />
      <Helmet>
        <title>{alt}</title>
      </Helmet>
      <Icon onClick={() => window.history.back()}>
        <LeftIcon />
      </Icon>
      <CartDropdown />
      <NavContainer>
        <NavLogo to="/">
          <Img
            src="https://res.cloudinary.com/coximomentz/image/upload/v1618724481/coxibakery_jv1oo2.svg"
            alt="coxibakery-logo-k5sgfn"
          />
        </NavLogo>
        <NavButton>
          <CartIcon />
        </NavButton>
      </NavContainer>
      <ProductDetailContainer>
        <ProductDetailWrapper>
          <ProductImageContainer>
            <BigImageWrap>
              {featured ? (
                <ChefImageWrap>
                  <Img src={Chef} alt="chef" width="400" height="auto" />
                </ChefImageWrap>
              ) : null}
              {premium ? (
                <PremiumImageWrap>
                  <Img src={Premium} alt="premium" width="400" height="auto" />
                </PremiumImageWrap>
              ) : null}
              {newFlavour ? (
                <NewImageWrap>
                  <Img src={New} alt="new" width="400" height="auto" />
                </NewImageWrap>
              ) : null}
              <ImageOverflowWrap>
                <Img src={selectedImg} alt="selected" />
              </ImageOverflowWrap>
            </BigImageWrap>
            <ImageContainer>
              {gallery.map((image, index) => (
                <SmallImageWrap key={index}>
                  <Img src={image} alt={alt} onClick={() => setSelectedImg(image)} />
                </SmallImageWrap>
              ))}
            </ImageContainer>
            <ReferenceOnlyP>
              {custom
                ? "*Cake size may be variant in the illustration."
                : "*Cake size may be variant in the illustration, please select your preference size."}
            </ReferenceOnlyP>
          </ProductImageContainer>
          <ProductInfoContainer>
            <Title>
              {custom ? "" : size} {name}
            </Title>
            <Description>{description}</Description>
            <CakePrice>RM {cakePrice}</CakePrice>
            {custom ? <RemarksP>*Remember to add your favourite number in the remark section later.</RemarksP> : null}
            <DTSelectorWrapper>
              <SelectInput
                removeSpacing
                label="Cake Size*"
                name="cakeSize"
                handleChange={handleSizeChange}
                value={size}
                options={cakeSizeSelection(lineUp)}
              />
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  onClick={() => setIsOpen(!isForcePickerOpen)}
                  open={isForcePickerOpen}
                  onClose={() => setIsOpen(false)}
                  disablePast
                  InputProps={{ readOnly: true }}
                  minDate={dayAfterTomorrow}
                  shouldDisableDate={disabledDate}
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  placeholder="dd/MM/yyyy"
                  margin="normal"
                  id="date-picker"
                  label="Delivery Date"
                  value={deliveryDate}
                  onChange={handleDateChange}
                  keyboardIcon={<FiCalendar />}
                  KeyboardButtonProps={{ "aria-label": "change date" }}
                />
              </MuiPickersUtilsProvider>
              {error ? <ErrorMessage>{error}</ErrorMessage> : null}
              <SelectInput
                label="Delivery Time"
                name="deliveryTime"
                handleChange={handleTimeChange}
                value={deliveryTime}
                options={["Any Time", "Noon - 3 pm", "3 - 6 pm"]}
              />
            </DTSelectorWrapper>
            <TwoColumnInOneRow>
              <SelectInput
                removeSpacing
                label="Do you need candle?"
                name="candle"
                handleChange={handleCandleChange}
                value={candle}
                options={["No Candle", "Yes"]}
              />
            </TwoColumnInOneRow>
            {addOn && <AddonTitle>Addons</AddonTitle>}
            {addOn && <AddonSectionTitle>Birthday Tag/Cake Topper</AddonSectionTitle>}
            <TopperContainer>
              {addOn &&
                addOn.map((product) => (
                  <TopperWrapper key={product.id}>
                    <Img src={product.image} onClick={() => handleSelected(product)} />
                  </TopperWrapper>
                ))}
            </TopperContainer>
            {renderSelectedField(addonAccessories.name)}
            <AddonCardWrapper>
              <Checkbox
                name="Gift Card"
                value="Gift Card"
                type="checkbox"
                onChange={selectGiftCard}
                label="Gift Card +RM 8"
              />
            </AddonCardWrapper>
            {isGiftCard ? (
              <TextAreaInput
                autoComplete="none"
                name="giftCardNote"
                type="text"
                handleChange={(e) => setGiftCardNote(e.target.value)}
                value={giftCardNote}
                label="Message (max. characters 200)"
                maxLength={200}
                rows={3}
              />
            ) : null}
            <AddToCartButton onClick={handleSubmit}>Add to Basket</AddToCartButton>
            {error ? (
              <AlertMessage>
                <AlertIcon />
                {error}
              </AlertMessage>
            ) : null}
          </ProductInfoContainer>
        </ProductDetailWrapper>
      </ProductDetailContainer>
      {window.innerWidth <= 530 ? (
        <Player autoplay loop src={lottie} style={{ width: "320px", height: "320px" }}></Player>
      ) : (
        <Player autoplay loop src={lottie} style={{ width: "530px", height: "530px" }}></Player>
      )}
      <Tabs info={lineUp} />
      <Footer />
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  addCake: (item) => dispatch(addCake(item)),
  toggleCartHidden: () => dispatch(toggleCartHidden()),
  closeCart: () => dispatch(toggleCloseCart()),
})

const mapStateToProps = (state, ownProps) => ({
  showDropdown: selectCartHidden(state),
  itemCount: selectCartItemsCount(state),
  lineUp: selectSingleLineUpCake(ownProps.match.params.id)(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails)

// <meta property="og:title" content={name} />
//                 <meta property="og:description" content={description} />
//                 <meta property="og:image" content={image} />
//                 <meta property="og:url" content={`https://coxibakery-staging.herokuapp.com/product-details/${id}`} />
//                 <meta property="og:image:width" content="1200" />
//                 <meta property="og:image:height" content="1200" />

// <IllustrationContainer>
//     <IllustrationWrapper>
//         <Img
//             src={Signature}
//             alt="roundGradient"
//             width="300"
//             height="auto" />
//     </IllustrationWrapper>
// </IllustrationContainer>

// options={custom ? ['Custom Size'] : ['4 Inch', '6 Inch', '7 Inch', '8 Inch']}

// <TwoColumnInOneRow>
//                 <SelectInput
//                   removeSpacing
//                   label="Big Candle"
//                   name="bigCandle"
//                   handleChange={handleBigCandleChange}
//                   value={bigCandle}
//                   options={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}
//                 />
//                 <SelectInput
//                   removeSpacing
//                   label="Small Candle"
//                   name="smallCandle"
//                   handleChange={handleSmallCandleChange}
//                   value={smallCandle}
//                   options={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}
//                 />
//               </TwoColumnInOneRow>

// const [bigCandle, setBigCandle] = useState("0")
// const [smallCandle, setSmallCandle] = useState("0")

// const handleBigCandleChange = (event) => {
//   setBigCandle(event.target.value)
// }

// const handleSmallCandleChange = (event) => {
//   setSmallCandle(event.target.value)
// }

// <AddonSelector key={index} object={object} handleChange={() => handleAddOnItemChange(object)} />
